import { FC } from 'react'
import { LucideIcon } from 'lucide-react'
import { Tool } from './Tool.tsx'

export type ActionProps = {
    icon?: LucideIcon
    iconTitle?: string
    action: () => void
}

type TitleProps = {
    title: string
    action?: ActionProps
}

export const Title: FC<TitleProps> = ({ title, action }) => {
    const actionOnly = action?.action && !action.icon

    return (
        <div
            className={`text-lg font-bold pb-3 ${actionOnly ? 'cursor-pointer' : ''}`}
            onClick={() => {
                if (!action?.icon && action?.action) {
                    action.action()
                }
            }}
        >
            <div className={'flex flex-row justify-between items-center w-full h-8'}>
                <span>{title}</span>
                {action?.icon && <Tool title={action.iconTitle} action={action?.action} icon={action.icon} />}
            </div>
        </div>
    )
}
